// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { showConfirmDialog } from "./helpers/confirm_dialog"

Turbo.config.forms.confirm = showConfirmDialog

// Default is 500ms — long enough that a typical 250–400ms navigation feels
// like a dead tap on mobile. 100ms shows the progress bar almost
// immediately, giving the user feedback that their click was received.
Turbo.config.drive.progressBarDelay = 100

// Register the offline HTML cache. Network-first; cache is only served
// when fetch fails. PouchDB owns data; this just remembers the last
// HTML the server sent for each URL the user visited.
//
// `updateViaCache: "none"` makes the browser bypass its HTTP cache when
// checking for SW updates. Combined with `Cache-Control: no-cache` on
// the SW response (config/initializers/pwa_cache_control.rb), this lets
// server-side SW changes reach already-installed clients in minutes
// instead of up to 24 hours on iOS WKWebView.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js", { scope: "/", updateViaCache: "none" })
    .catch((err) => console.warn("SW registration failed:", err))
}
